import appModule from './app.module';

appModule.run(
    (
        $q,
        $transitions,
        $location,
        authenticationService,
        navigationService,
        redirectService,
        userAccessService,
        sessionService,
        sessionTypeConstants
    ) => {
        var promiseCache = {};

        $transitions.onBefore({}, transition => {
            var tokenInUrl = $location.search().token;
            if (tokenInUrl) {
                authenticationService.clearSession(false);
                authenticationService.setToken(tokenInUrl);
                $location.search('token', null);
            }

            var deferred = $q.defer();

            var sessionType = sessionService.getSessionType();
            if (sessionType == sessionTypeConstants.guest) {
                navigationService.setSelectedState(transition.to());

                if (!transition.to().protected) {
                    deferred.resolve();
                    return true;
                }

                var guestAccess = userAccessService.getGuestUserAccess();

                if (!guestAccess || guestAccess.length == 0) {
                    authenticationService.logout(true);
                    redirectService.onError('unauthorized');
                    deferred.reject();

                    return deferred.promise;
                }

                if (guestAccess.indexOf(transition.to().name) == -1) {
                    deferred.resolve(
                        transition.router.stateService.target(guestAccess[0])
                    );
                    return deferred.promise;
                }

                deferred.resolve();

                return deferred.promise;
            }

            var promiseId = 'transitionStart';
            if (promiseCache[promiseId]) {
                return promiseCache[promiseId].promise;
            }

            promiseCache[promiseId] = deferred;

            authenticationService
                .getToken()
                .then(token => {
                    if (!transition.to().protected) {
                        deferred.resolve();
                        return true;
                    }

                    if (!token) {
                        authenticationService.logout(false, transition.to());

                        deferred.resolve(false);
                        return;
                    }

                    authenticationService.verifyToken().then(
                        () => {
                            navigationService.setSelectedState(transition.to());

                            userAccessService.getUserAccess().then(
                                data => {
                                    if (!data || data.length == 0) {
                                        authenticationService.logout(true);
                                        redirectService.onError('unauthorized');
                                        deferred.reject();
                                        return false;
                                    }

                                    if (
                                        data.indexOf(transition.to().name) == -1
                                    ) {
                                        deferred.resolve(
                                            transition.router.stateService.target(
                                                data[0]
                                            )
                                        );
                                        return true;
                                    }

                                    deferred.resolve();
                                },
                                data => {
                                    if (data.unauthorized) {
                                        redirectService.onError('unauthorized');
                                        deferred.reject(data);
                                    }
                                }
                            );
                        },
                        () => {
                            deferred.reject();
                            authenticationService.logout(false);
                        }
                    );
                }, deferred.reject)
                .finally(() => delete promiseCache[promiseId]);

            return deferred.promise;
        });
    }
);

appModule.factory('authenticateInterceptor', [
    '$q',
    '$sessionStorage',
    '$window',
    '__env',
    'sessionStorageConstants',
    'sessionTypeConstants',
    'asNotifier',
    '$injector',
    AppAuthenticationInterceptor
]);

function AppAuthenticationInterceptor(
    $q,
    $sessionStorage,
    $window,
    __env,
    sessionStorageConstants,
    sessionTypeConstants,
    asNotifier,
    $injector
) {
    function isGetTokenApi(httpMethod, url) {
        return (
            httpMethod.toUpperCase() === 'GET' &&
            url === `${__env.cloudApiUrl}/api/v1/appspace/token`
        );
    }

    function isGenerateGuestTokenApi(httpMethod, url) {
        return (
            httpMethod.toUpperCase() === 'POST' &&
            url === `${__env.billingApiUrl}/api/v1/guest-token`
        );
    }

    return {
        request: config => {
            const deferred = $q.defer();

            if (
                config.url.startsWith(`${__env.cloudApiUrl}/api`) &&
                !isGetTokenApi(config.method, config.url)
            ) {
                const authenticationService = $injector.get(
                    'authenticationService'
                );
                authenticationService.getToken().then(token => {
                    config.headers.token = token;

                    deferred.resolve(config);
                }, deferred.reject);
            } else {
                deferred.resolve(config);
            }

            return deferred.promise;
        },
        responseError: response => {
            const config = response.config;
            const sessionType = sessionStorageConstants.sessionType;
            const guestBillingUrl = '/#!/billing/guest';

            if (
                response.status === 401 &&
                !isGenerateGuestTokenApi(config.method, config.url)
            ) {
                if (
                    $sessionStorage[sessionType] === sessionTypeConstants.guest
                ) {
                    $window.location.href = guestBillingUrl;

                    /*
                        Using a timeout because after this interceptor the rejected response
                        is still returned to the caller. Thus, an error notification will
                        still be shown after clearing them.
                        As of this comment, there is no way to return a generic resolved
                        response.
                    */
                    setTimeout(() => {
                        asNotifier.clearAllNotifications();
                    }, 50);
                } else {
                    var currentUrl = encodeURI($window.location.href).replace(
                        /#/g,
                        '%23'
                    );
                    $window.location.href =
                        __env.cloudUrl +
                        '/cs/#!/login?message=account&mode=account&ReturnUrl=' +
                        currentUrl;
                }
            }
            return $q.reject(response);
        }
    };
}

appModule.config([
    '$httpProvider',
    function($httpProvider) {
        $httpProvider.interceptors.push('authenticateInterceptor');
    }
]);



// WEBPACK FOOTER //
// ./app.auth.js